import { inject, Injectable } from '@angular/core';
import {
  adobeClickEventAnalyticsMocks,
  ANALYTICS_EVENTS,
  AnalyticsService,
  ClickEventAnalytics,
  EVENT_CLICK_TYPE,
  HEADER_MENU,
  HEADER_TOP_MENU,
  PageLoadAnalytics,
  USER_LOGGED_IN_STATUS,
  removeDomainName
} from '@com-delta-idp/mnx-utils';
import { take } from 'rxjs/operators';
import { AccountSummaryService } from '../accountsummary/account-summary.service';

@Injectable({
  providedIn: 'root'
})
export class AdobeDataLayerService {
  protected accountSummary = inject(AccountSummaryService);
  protected analytics = inject(AnalyticsService);

  constructor() {}

  removeCountryLanguageFromUrl(url: string): string {
    if (!url) return '';
    try {
      const removeCountryLangPattern = /^\/([a-z]{2,5})\/([a-z]{2})\/(.+)$/;
      const match = url.match(removeCountryLangPattern);
      return match ? `/${match[3]}` : url;
    } catch {
      return '';
    }
  }

  setUserDataInAnalytics(data: ClickEventAnalytics | PageLoadAnalytics): void {
    this.accountSummary
      .getAccountSummaryDetails()
      .pipe(take(1))
      .subscribe((userStatus) => {
        const isLoggedIn = userStatus && Object.keys(userStatus).length > 0;
        data = {
          ...data,
          ...{
            user: {
              attributes: {
                is_logged_in: isLoggedIn
                  ? USER_LOGGED_IN_STATUS.AUTHENTICATED
                  : USER_LOGGED_IN_STATUS.UNAUTHENTICATED,
                login_state: isLoggedIn ? '' : USER_LOGGED_IN_STATUS.COLD
              }
            }
          }
        };
        this.analytics.setAnalytics(data);
      });
  }

  updateAnalytics(url: string, navItem: string, subNavItem = ''): void {
    let headerMenu: Record<string, string> = {};
    if (subNavItem !== '') {
      headerMenu = HEADER_MENU[navItem][subNavItem];
    } else {
      headerMenu = HEADER_MENU[navItem];
    }
    const { NAME, PAGE_SECTION } = headerMenu;
    let data = adobeClickEventAnalyticsMocks;
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: this.checkHeaderNav(PAGE_SECTION, 'header'),
      click: {
        name: NAME,
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: PAGE_SECTION,
        action:
          url?.startsWith('/') || url?.startsWith('http')
            ? this.analytics.getCleanUrl(url)
            : ANALYTICS_EVENTS.NAV_CLICK
      }
    };
    this.setUserDataInAnalytics(data);
  }

  checkHeaderNav(pageSection: string, headerStr: string): string {
    return pageSection.includes(headerStr)
      ? ANALYTICS_EVENTS.NAV_CLICK
      : ANALYTICS_EVENTS.CLICK;
  }

  appNavLinksAnalytics(
    navItem: string,
    secondaryNav: string,
    url: string
  ): void {
    const menus = {
      secondarynav: HEADER_TOP_MENU.TRAVEL_INFO,
      'sky-miles': HEADER_TOP_MENU.SKYMILES,
      more: HEADER_TOP_MENU.NEED_HELP
    };
    let data = adobeClickEventAnalyticsMocks;
    const { NAME, PAGE_SECTION } = HEADER_MENU[menus[navItem]];
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: this.checkHeaderNav(PAGE_SECTION, 'header'),
      click: {
        name: secondaryNav,
        type: EVENT_CLICK_TYPE.LINK,
        page_section: `${PAGE_SECTION}:${secondaryNav}`,
        action: this.analytics.getCleanUrl(url)
      }
    };
    this.setUserDataInAnalytics(data);
  }
}
